module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot03_point-143ba9016692469b95cf6ba3b05942c9.jpg";